import { Component, computed, inject, input } from '@angular/core';
import { findDashboardLeaf } from '@cumlaude/shared-dashboard-registry';
import { stripQueryParams } from '@cumlaude/shared-services';
import { FilteringTekstService } from '../../../services/filtering-tekst.service';

@Component({
	selector: 'app-pagina-samenvatting',
	templateUrl: './pagina-samenvatting.component.html',
	styleUrls: ['./pagina-samenvatting.component.scss'],
})
export class PaginaSamenvattingComponent {
	private readonly filteringTekstService = inject(FilteringTekstService);

	readonly url = input.required<string>();
	readonly titel = input<string>();

	private readonly pad = computed(() => stripQueryParams(this.url()));
	private readonly leaf = computed(() => findDashboardLeaf(this.pad()));

	readonly weergaveTitel = computed(() => this.titel() ?? this.leaf()?.titel ?? '');
	readonly hoofdpagina = computed(() => this.leaf()?.hoofdpagina);
	readonly filteringTekst = computed(() => this.filteringTekstService.bepaalFilteringTekst(this.url()));
}
